export default (px: number): string =>
  // The max() CSS function does not work on the FireTV because the version of Android is using Chrome 66.
  // To properly support mobile device we can bring this back by testing if max() is supported somehow.
  `max(${(px / 1920) * 100}vw, ${px / 2}px)`;
